import React from 'react';
import AdSlot from "./AdSlotComponent";

import Card from './ui/Card';

function Privacidade() {
    return (
        <Card
            className="p-6 max-w-3xl mx-auto"
            data-editorial-content="true"
        >
            <h1 className="text-2xl font-bold mb-4">Política de Privacidade</h1>
            <p className="mb-2">
                O Pleini Pouquer respeita sua privacidade. Para criar salas, entrar em sessões e
                participar do Planning Poker, é necessário login com conta Google. Nesse processo,
                recebemos do Google informações básicas do perfil: identificador da conta, e-mail,
                nome exibido e foto (quando disponíveis).
            </p>
            <p className="mb-2">
                Utilizamos esses dados para autenticar o acesso às salas, exibir seu nome na sessão
                (você pode editá-lo antes de entrar) e registrar estatísticas de salas criadas por
                usuário. O registro de criação de sala (identificador da sala, data e vínculo com
                sua conta Google) pode ser persistido em banco de dados. Votos, histórias e
                participantes ativos permanecem temporários em memória durante a sessão.
            </p>
            <p className="mb-2">
                Páginas informativas (guia, FAQ, recursos, sobre e privacidade) podem ser acessadas
                sem login. Preferências locais (por exemplo, consentimento de cookies e dados de
                sala no navegador) são armazenadas no seu dispositivo.
            </p>
            <h2 className="text-lg font-semibold mt-4 mb-2">Cookies e terceiros</h2>
            <p className="mb-2">
                O site pode utilizar cookies técnicos ou de preferência para melhorar a experiência.
                Anúncios (por exemplo, via Google AdSense) podem usar cookies de terceiros conforme
                as políticas do provedor. Recomendamos ler as configurações de privacidade do seu
                navegador se quiser gerenciar o uso de cookies.
            </p>
            <p className="mb-2">
                Última atualização: esta política reflete as práticas atuais do Pleini Pouquer.
                Em caso de alterações relevantes, a data será atualizada nesta página.
            </p>
            <>
                {/* Anúncio após conteúdo */}
                <AdSlot adSlot="7348901130475950" format="auto" />
            </>
        </Card>
    );
}

export default Privacidade;
